import { render, staticRenderFns } from "./viewdetail.vue?vue&type=template&id=17881f89&scoped=true&"
import script from "./viewdetail.vue?vue&type=script&lang=js&"
export * from "./viewdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17881f89",
  null
  
)

export default component.exports